/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from "react";
import Character from "../Character";
import MaxWidthWrapper from "../MaxWidthWrapper";
import ControlPane from "../ControlPane";
import Dropdown from "@asphalt-react/dropdown";
import styles from "./CharacterEditor.module.css";
import _ from "lodash";
import Loader from "../Loader";
import axios from "axios";
let categorySelector = [];

function App() {
  const [selectedCategory, setSelectedCategory] = React.useState("Ride");
  const [selectedGender, setSelectedGender] = React.useState("Man");
  const [selectedItem, setSelectedItem] = React.useState({
    id: 1,
    skin: "skin_001",
  });
  const [selectedSkin, setSelectedSkin] = React.useState({
    id: 1,
    skin: "skin_001",
  });
  const activeSelection = function (item) {
    setSelectedItem(item);
  };
  const [genderMan, setGenderMan] = React.useState(false);
  const [genderWoman, setGenderWoman] = React.useState(false);
  const [DATA, setDATA] = React.useState();
  let combinedParts = [];

  function generateCombinedParts(allParts) {
    combinedParts.push(allParts);
  }

  function selectFirstItem() {
    if (DATA !== undefined) {
      /* If the category has man parts only */
      if (
        DATA[selectedCategory.toLocaleLowerCase()].man === true &&
        DATA[selectedCategory.toLocaleLowerCase()].woman === true
      ) {
        setGenderMan(true);
        setGenderWoman(false);
        setSelectedGender("Man");
      }

      /* If the category has woman parts only */
      if (
        DATA[selectedCategory.toLocaleLowerCase()].man === false &&
        DATA[selectedCategory.toLocaleLowerCase()].woman === true
      ) {
        setGenderMan(false);
        setGenderWoman(true);
        setSelectedGender("Woman");
      }

      /* If the category has man and woman parts */
      if (
        DATA[selectedCategory.toLocaleLowerCase()].man === true &&
        DATA[selectedCategory.toLocaleLowerCase()].woman === false
      ) {
        setGenderMan(true);
        setGenderWoman(false);
        setSelectedGender("Man");
      }
    }
  }

  const listOfControlPane =
    DATA !== undefined &&
    _.toArray(DATA[selectedCategory.toLocaleLowerCase()].parts).map((item) => {
      return (
        <ControlPane
          key={item.title}
          data={item}
          activeSelection={activeSelection}
          generatedParts={generateCombinedParts}
          genderSelected={selectedGender}
          categorySelected={selectedCategory}
        />
      );
    });

  React.useEffect(() => {
    axios({
      method: "get",
      url: "https://api.jsonbin.io/v3/b/6576d362266cfc3fde674516",
      responseType: "stream",
    }).then(function (response) {
      setDATA(response.data.record);
    });
  }, []);

  React.useEffect(() => {
    _.toArray(DATA).forEach((item) => {
      categorySelector.push({
        id: item.id,
        key: item.label,
        selected: item.selected,
      });
    });
    selectFirstItem();
  }, [DATA]);

  React.useEffect(() => {
    selectFirstItem();
  }, [selectedCategory]);

  if (DATA === undefined) {
    return <Loader />;
  }

  return (
    <main className={styles.characterEditor}>
      <header className={styles.header}>
        <h1 className={styles.title}>Build your Character</h1>
        <p className={styles.description}>
          Customize your character's look and style using the controls below.
        </p>
      </header>
      <MaxWidthWrapper className={styles.maxWidthWrapper}>
        <div className={styles.controlColumn}>
          <div className={styles.setSelector}>
            {categorySelector.length === 0 ? null : (
              <Dropdown
                items={categorySelector}
                stretch={true}
                onChange={(item) => {
                  setSelectedCategory(item.key);
                  setGenderMan(true);
                  setGenderWoman(true);
                }}
              />
            )}
          </div>
          <div className={styles.genderSelectorContainer}>
            {DATA[selectedCategory.toLocaleLowerCase()].man === true && (
              <button
                aria-pressed={genderMan}
                className={styles.genderSelector}
                onClick={() => {
                  setGenderMan(true);
                  setGenderWoman(false);
                  setSelectedGender("Man");
                }}
              >
                <img src={`${process.env.PUBLIC_URL}/man.svg `} alt="Man" />
                Man
              </button>
            )}
            {DATA[selectedCategory.toLocaleLowerCase()].woman === true && (
              <button
                aria-pressed={genderWoman}
                className={styles.genderSelector}
                onClick={() => {
                  setGenderMan(false);
                  setGenderWoman(true);
                  setSelectedGender("Woman");
                }}
              >
                <img src={`${process.env.PUBLIC_URL}/woman.svg `} alt="Man" />
                Woman
              </button>
            )}
          </div>
          {/* <div className={styles.skinToneSelectorContainer}>{skinsControl}</div> */}
          <div className={styles.controlPaneContainer}>{listOfControlPane}</div>
        </div>
        <div className={styles.characterWrapper}>
          <Character
            combinedParts={combinedParts}
            selectedCategory={selectedCategory}
            selectedItem={selectedItem}
            genderSelected={selectedGender}
          />
        </div>
      </MaxWidthWrapper>
    </main>
  );
}

export default App;
